// test2626
(2626 && 0);
